import React, { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const inputCls =
  "w-full bg-[#1A1D26] border border-[#282D3D] rounded-lg py-2 px-3 text-white text-xs focus:outline-none focus:border-[#FF6B00]";

export const ChangePasswordCard = () => {
  const { session, changePassword } = useAuth();
  const needsCurrent = !!session;
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (next.length < 6) return setError("A nova senha precisa ter no mínimo 6 caracteres.");
    if (next !== confirm) return setError("As senhas não coincidem.");
    setSaving(true);
    try {
      await changePassword(needsCurrent ? current : null, next);
      toast.success("Senha alterada com sucesso.");
      setCurrent(""); setNext(""); setConfirm("");
    } catch (err) {
      setError(err?.response?.data?.detail || "Não foi possível alterar a senha.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <form data-testid="change-password-card" onSubmit={submit} className="bg-[#14161C] border border-[#282D3D] rounded-xl p-5 space-y-3">
      <h3 className="text-sm font-bold text-white flex items-center gap-2">
        <KeyRound className="w-4 h-4 text-[#FF6B00]" /> Alterar senha
      </h3>
      {!needsCurrent && (
        <p className="text-[11px] text-gray-400">Você entrou com Google. Defina uma senha para também poder entrar com e-mail.</p>
      )}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
        {needsCurrent && (
          <input type="password" required placeholder="Senha atual" data-testid="change-password-current-input" value={current} onChange={(e) => setCurrent(e.target.value)} className={inputCls} />
        )}
        <input type="password" required minLength={6} placeholder="Nova senha" data-testid="change-password-new-input" value={next} onChange={(e) => setNext(e.target.value)} className={inputCls} />
        <input type="password" required minLength={6} placeholder="Confirmar nova senha" data-testid="change-password-confirm-input" value={confirm} onChange={(e) => setConfirm(e.target.value)} className={inputCls} />
      </div>
      {error && <p data-testid="change-password-error" className="text-[11px] text-red-400">{error}</p>}
      <button type="submit" disabled={saving} data-testid="change-password-submit-btn" className="px-4 py-2 rounded-lg bg-[#FF6B00] hover:bg-[#FF8533] text-black font-extrabold text-xs uppercase tracking-wider disabled:opacity-60 transition-colors">
        {saving ? "Salvando..." : "Salvar nova senha"}
      </button>
    </form>
  );
};
